import React from "react";
import { Card, Switch } from "antd";

const VisibilitySettings = ({ widget, handleWidgetChange }) => {
  const handleChange = (e, label) => {
    handleWidgetChange({ [label]: e, id: widget.id });
  };

  return (
    <Card className="setting_wrapper">
      <h4 className="p-color">Visibility Settings</h4>

      <ul className="switch_lst">
        <li>
          <Switch
            id="custom-switch"
            onChange={(e) => handleChange(e, "widgetOffline")}
            defaultChecked={widget?.widgetOffline}
            checked={widget?.widgetOffline}
          />
          <span>Hide widget when offline</span>
        </li>

        {/* <li>
          <Switch
            id="custom-switch"
            disabled={!isEditAble}
            onChange={(e) => handleChange(e, "widgetLoadDesktop")}
            defaultChecked={widget?.widgetLoadDesktop}
            checked={widget?.widgetLoadDesktop}
          />
          <span>Hide widget on load in desktop</span>
        </li>

        <li>
          <Switch
            id="custom-switch"
            disabled={!isEditAble}
            onChange={(e) => handleChange(e, "widgetLoadDesktop")}
            defaultChecked={widget?.widgetLoadDesktop}
            checked={widget?.widgetLoadDesktop}
          />
          <span>Hide widget on load in mobile</span>
        </li> */}
      </ul>
    </Card>
  );
};

export default React.memo(VisibilitySettings);
